import MicroSingleStartPage from 'components/MapoAdministration/components/Content-Management/MicroSingleStartPage';

const ScreenMicroSingleStartPage = () => <MicroSingleStartPage />;

export default ScreenMicroSingleStartPage;
